import { trackCroEvent } from "@/shared/utils/croModals";
import { readStoredUtm } from "@/shared/utils/utm";

/** The Manager's start/startapp payload is intentionally not invented here. */
export function managerUrl(value = process.env.NEXT_PUBLIC_TEZAM_MANAGER_URL): string | null {
    try {
        const url = new URL(value?.trim() || "");
        if (url.protocol !== "https:" || url.hostname !== "t.me" || url.username || url.password || url.port)
            return null;
        if (!/^\/[a-zA-Z0-9_]{5,32}(\/[a-zA-Z0-9_]+)?\/?$/.test(url.pathname)) return null;
        return url.toString();
    } catch {
        return null;
    }
}

/** После авторизации — мастер создания в кабинете. */
export function cabinetCreateHref(
    industry?: string,
    plan?: string,
    niche?: string,
    promo?: string,
): string {
    const q = new URLSearchParams();
    if (industry) q.set("industry", industry);
    if (plan) q.set("plan", plan);
    if (niche) q.set("niche", niche);
    if (promo) q.set("promo", promo);
    return `/cabinet/create${q.size ? `?${q.toString()}` : ""}`;
}

/** CTA «Создать» → вход/регистрация, затем мастер в кабинете. */
export function startHref(industry?: string, plan?: string, niche?: string, promo?: string): string {
    const next = cabinetCreateHref(industry, plan, niche, promo);
    const auth = new URLSearchParams();
    auth.set("tab", "register");
    auth.set("next", next);
    return `/auth?${auth.toString()}`;
}

export function trackMarketing(event: string, params: Record<string, string | number | undefined> = {}) {
    trackCroEvent(event, { ...params, landing_version: "niche-2026-10-v2" });
}

/** Preserve attribution across reloads and allowlisted local navigation only. */
export function attributedHref(href: string): string {
    if (typeof window === "undefined" || !href.startsWith("/")) return href;
    const url = new URL(href, window.location.origin);
    for (const [key, value] of Object.entries(readStoredUtm())) {
        if (/^utm_(source|medium|campaign|content|term)$/.test(key) && typeof value === "string") {
            url.searchParams.set(key, value.slice(0, 200));
        }
    }
    return `${url.pathname}${url.search}${url.hash}`;
}
